export const WHATS_CONST = {
  LEDGER: {
    title: 'Ledger Report',
    discription: 'A statement that shows the details of all fund transactions.'
  },
  CONTRACT: {
    title: 'Contract Notes',
    discription:
      'A contract note is a summary of all trades executed on a specific day.'
  }
}
